import type { FunctionComponent, ReactNode } from 'react';

import S from './style.scss';

type KindT = 'blue' | 'green' | 'grey' | 'red';

type PropsT = {
  children: ReactNode;
  kind: KindT;
};

export const Pill: FunctionComponent<PropsT> = ({ children, kind }) => {
  let className: string;

  switch (kind) {
    case 'blue':
      className = S.blue;
      break;
    case 'green':
      className = S.green;
      break;
    case 'grey':
      className = S.grey;
      break;
    case 'red':
      className = S.red;
      break;
    default: throw Error('Unexpected kind');
  }

  className += ` ${S.container}`;

  return <div className={className}>{children}</div>;
};
